import React from "react";
import styled from "styled-components";
import { TabletDown, toRem } from "theme/Breakpoints";
import { colors } from "theme/Theme";
import MobileCartButton from "features/cart/MobileCartButton";
import { BottomBarItem, PhoneButton, MobileCompareButton, FilterButton } from ".";
import { useLocation } from "react-router-dom";
import { isIOS } from "react-device-detect";

interface MobileBottomBarProps {}

const MobileBottomTabBar: React.FC<MobileBottomBarProps> = ({}) => {
  const location = useLocation();

  const isSitemap = location.pathname?.includes("sitemap");
  const isLogin = location.pathname?.includes("asparuh");
  if (isSitemap || isLogin) return null;

  return (
    <TabletDown>
      <MobileBottomBarContainer isIOS={isIOS}>
        <BottomBarItem>
          <PhoneButton />
        </BottomBarItem>
        <BottomBarItem>
          <MobileCartButton />
        </BottomBarItem>
        <BottomBarItem>
          <MobileCompareButton />
        </BottomBarItem>
        <BottomBarItem>
          <FilterButton />
        </BottomBarItem>
      </MobileBottomBarContainer>
    </TabletDown>
  );
};

const MobileBottomBarContainer = styled.div<{ isIOS: boolean }>`
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: ${toRem(50)};
  background-color: ${colors.light_blue};
  z-index: 90;
  position: sticky;
  bottom: 0;

  @media (orientation: portrait) {
    padding-bottom: ${(props) => (props.isIOS ? "calc(0.375rem + env(safe-area-inset-bottom))" : "0px")};
  }
`;

export default MobileBottomTabBar;
